import { useEffect, useMemo, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import * as Yup from 'yup'
import { VALIDATION_MESSAGES } from '../../../utility/constantValidationMessages'
import { ROUTES_PATH } from '../../../utility/constants'
import { ErrorMessage, Form, Formik } from 'formik'
import BreadCrumbs from '../../../components/breadcrumb/Breadcrumb'
import PageDropdown from '../../../components/page-dropdown/PageDropdown'
import Button from '../../../components/button/Button'
import ReportDataTable from '../../../components/report-table/ReportDataTable'
import './lectureCountReport.scss'
import { convertTZToDate, exportToExcel, generateDropdownOptions } from '../../../utility/genricFunction'
import { getBatchFromBranch, getFacultyLectureCountReport } from '../../../store/builders/reports/reports.builder'
import PrintIcon from '@mui/icons-material/Print';
import SimCardDownloadIcon from '@mui/icons-material/SimCardDownload';
import { useReactToPrint } from 'react-to-print'
import Loader from '../../../components/loader/Loader'

function LactureCountReport() {

    const dispatch = useDispatch()

    const {loading, pageDropDownLoading} = useSelector((store) => store.reports)

    const batches = useSelector((store) => store.reports.batches)
    const batchOptions = useMemo(() => generateDropdownOptions(batches, 'batchNo', 'batchId'), [batches])

    const lectureCountData = useSelector((store) => store?.reports?.facultyLectureCountReportData)
    const branches = useSelector((state) => state?.branch?.branchTableData)
    const branchOption = useMemo(() => generateDropdownOptions(branches, 'branchName', 'branchId'), [branches])

    const userRole = useSelector((state) => state.auth?.user?.result?.userData?.roleName) || {}
    const branchId = useSelector((state) => state.auth?.user?.result?.userData?.branchId)

    const [branch, setBranch] = useState("")
    const [batch, setBatch] = useState("")
    const [isTableOpen, setIsTableOpen] = useState(false)

    const [initialValues] = useState({
        branch: userRole == "branch" ? branchId : '',
        batch: ''
    })

    useEffect(() => {
        if (userRole == "branch") {
            dispatch(getBatchFromBranch(branchId))
        }

    }, [])

    const validationSchema = Yup.object().shape({
        branch: Yup.string()
            .required(VALIDATION_MESSAGES.BRANCH_FORM.BRANCH_NAME_REQUIRED),
        batch: Yup.string()
            .required(VALIDATION_MESSAGES.BATCH_REQUIRED),
    })

    function handleFormSubmit(values) {

        setBranch(values.branch)
        setBatch(values.batch)
        // setIsTableOpen(true)

        const data = {
            branch: values.branch,
            batch: values.batch,
        }

        dispatch(getFacultyLectureCountReport({data, setIsTableOpen}))
    }

    const handleBranchChange = (value, setFieldValue) => {
        setFieldValue("branch", value)
        dispatch(getBatchFromBranch(value))
    }

    const dateBody = (reportData) => {
        const representative = reportData?.date && convertTZToDate(reportData?.date)
        return (
            <div className='flex align-items-center gap-2'>
                <span>{representative}</span>
            </div>
        )
    }

    const typeBody = (reportData) => {
        const representative = reportData?.type && reportData?.type.split("_").join(" ")
        return (
            <div className='flex align-items-center gap-2'>
                <span>{representative}</span>
            </div>
        )
    }


    const breadCrumbsArr = [
        {
            title: 'Lecture count details',
            link: null,
        },
        {
            title: 'Dashboard',
            link: ROUTES_PATH.DASHBOARD,
        },
        {
            title: 'Lecture count',
            link: ROUTES_PATH.LECTURE_COUNT_REPORT,
        },
    ]

    const columns = [
        {
            field: 'no',
            header: "#",
            filter: false,
            filterDisplay: 'row',
            style: { minWidth: '2rem' },
        },
        {
            field: 'date',
            header: "Date",
            filter: false,
            filterDisplay: 'row',
            style: { minWidth: '12rem' },
            body: dateBody
        },
        {
            field: 'classTime',
            header: "Classtime",
            filter: false,
            filterDisplay: 'row',
            style: { minWidth: '15rem' },
        },
        {
            field: 'batch',
            header: "Batch",
            filter: false,
            filterDisplay: 'row',
            style: { minWidth: '12rem' },
        },
        {
            field: 'type',
            header: "Lecture/Exam",
            filter: false,
            filterDisplay: 'row',
            style: { minWidth: '12rem' },
            body: typeBody,
        },
        {
            field: 'moduleName',
            header: "Module",
            filter: false,
            filterDisplay: 'row',
            style: { minWidth: '12rem' },
        },
        {
            field: 'count',
            header: "Count",
            filter: false,
            filterDisplay: 'row',
            style: { minWidth: '8rem' },
        },
    ]

    const printRef = useRef()

    const handleDownloadPfd = useReactToPrint({
        content: () => printRef.current,
    });



    return (
        <>
        {loading && <Loader loading={loading} />}
        {<Loader loading={loading} /> &&  <div className='lectureCountReport-wrapper'>
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={(values) => {
                    handleFormSubmit(values)
                }}
                enableReinitialize
            >
                {({ values, handleChange, handleSubmit, setFieldValue }) => (
                    <Form>
                        <div className='lectureCountReport-header'>
                            <BreadCrumbs breadCrumbsArr={breadCrumbsArr} />
                        </div>

                        <div className='lectureCountReport'>
                            <div className='lectureCountReport-input-fields'>

                                <div className='lectureCountReport-input'>
                                    <label htmlFor=''>
                                        Branch<span className='required-symbol'>*</span>
                                    </label>
                                    <PageDropdown
                                        loading={pageDropDownLoading}
                                        options={branchOption}
                                        selectedValue={values.branch}
                                        className={'lectureCountReport-dropdown'}
                                        onChange={(e) => handleBranchChange(e.target.value, setFieldValue)}
                                        name={'branch'}
                                        placeholder={'Select Branch'}
                                        disabled={userRole == "branch"}
                                    />
                                    <ErrorMessage name='branch' component='div' className='error-msg' />
                                </div>


                                <div className='lectureCountReport-input'>
                                    <label htmlFor=''>
                                        Batch<span className='required-symbol'>*</span>
                                    </label>
                                    <PageDropdown
                                        loading={pageDropDownLoading}
                                        options={batchOptions}
                                        selectedValue={values.batch}
                                        className={'lectureCountReport-dropdown'}
                                        onChange={handleChange}
                                        name={'batch'}
                                        placeholder={'Select Batch'}
                                    />
                                    <ErrorMessage name='batch' component='div' className='error-msg' />
                                </div>


                                <div className='report-submit-div'>
                                    <Button customClassName={'save-btn'} onClick={handleSubmit}>
                                        Submit
                                    </Button>
                                </div>
                            </div>

                        </div>
                    </Form>
                )}
            </Formik>

            {isTableOpen && <div className='lectureCountReport-table'>
                <div className='export-option-wrapper'>
                    <div className='pdf-excel-export'>
                        <Button
                            text={'Export'}
                            type={'button'}
                            onClick={() =>
                                exportToExcel(lectureCountData, columns, 'Faculty Lecture Count Report', 'FacultyLectureCountReport.xlsx')
                            }
                        ><SimCardDownloadIcon /></Button>
                        <Button
                            text={'Export'}
                            type={'button'}
                            onClick={handleDownloadPfd}
                        ><PrintIcon />
                        </Button>
                    </div>
                </div>



                <div ref={printRef} className='printable-component'>
                    {
                        lectureCountData.map((faculty, index) => {
                            return <>
                                <div className='report-heading-label-div' >{faculty.facultyName}</div>
                                <ReportDataTable
                                    columns={index == 0 ? columns : columns}
                                    //   header={index == 0 ? header : null} 
                                    value={faculty.data}
                                />
                            </>
                        })
                    }
                </div>
            </div>}
        </div>}
        </>
    )
}

export default LactureCountReport
